module.exports = __webpack_public_path__ + "static/img/jp5.3c5b6552.png";